module.exports = __webpack_public_path__ + "img/P150T_weapon_6.7bb9424e.png";